import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import Dragger from "antd/es/upload/Dragger";
import {hasDesktopBaseLicense, hasLicense, imgPathPerfix} from "../../utils";
import {ipcSend} from "../../common/ipc";
import {isZh} from "@/language";

const DialogImportFileVip = forwardRef((props:{onCloseEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [content,setContent] = useState({});

    const onShowDialog = (szTitle:string,szContent:string)=>{
        setContent({
            title:szTitle,
            content:szContent
        })
        setIsShowDialog(true);
    }

    return(
        <Modal centered={true} open={isShowDialog} closable={true} closeIcon={<IconClose/>} footer={''}
               onCancel={(e) => {
                   setIsShowDialog(false);
                   props.onCloseEvent();
               }} width='388px' bodyStyle={{margin:'-24px -20px'}}>
            <div className='font-size-12' style={{
                display: 'flex',
                padding: '20px 20px 10px 20px',
                flexDirection: 'column'
            }}>
                <div className='flex-row-vertical-center'>
                    <span className='dialog-title'>{content.title}</span>
                    <img className='img-18 ml-6' src={imgPathPerfix() + 'vip.png'}/>
                </div>

                <div className='line' style={{margin: '12px -16px'}}></div>
                <span
                    style={{color: '#666666', marginTop: '1px', lineHeight: '24px'}}>{content.content}</span>
                <div className='flex-center button-solid-style'
                     style={{width: '164px', height: '38px', marginTop: '20px', alignSelf: 'center'}} onClick={() => {
                    if (!hasLicense() && !hasDesktopBaseLicense()) {
                        if (isZh()) {
                            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                        }else {
                            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                        }
                    }
                }}>
                    <img className='img-18' src={imgPathPerfix() + 'vip_white.png'}/>
                    <span className='ml-6 font-family-medium'>{t("Try PRO")}</span>
                </div>

            </div>
        </Modal>
    )
})

export default DialogImportFileVip;